// extracted by mini-css-extract-plugin
export default {"wb_name":"styles_wb_name__6us-q"};